import React, { Fragment, useEffect, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, OverlayTrigger, Popover, Badge, Tooltip, Accordion, Button } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link, useLocation, useNavigate } from 'react-router-dom'


import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import { userSignal } from '../../../signal/userSignal';
import * as moment from 'moment';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import Circularprogressbar from '../../../components/circularprogressbar';
import SwiperCore, { Navigation } from "swiper";
import DataTable from 'react-data-table-component';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from '../../../signal/allUsersSignal';
import { dealerSignal } from '../../../signal/dealerSignal';
import CustomToggle from '../../../components/dropdowns';
import { confirmAlert } from 'react-confirm-alert';
import Avatar from 'react-avatar';
import { organisationSignal } from '../../../signal/organisationSignal';
import AddEditOrder from './AddEditOrder';
import TopLoader from "react-top-loader";
import EditTransportDetails from './EditTransportDetails';
import TallyInvoiceModal from './TallyInvoiceModal';
import AddReturnedItemModal from './AddReturnedItemModal';


// install Swiper modules
SwiperCore.use([Navigation]);

export default function OrderDetailsV2() {
    const [toggler, setToggler] = useState();
    const [order, setOrder] = useState({});
    const [user, setUser] = useState({})
    const [dealer, setDealer] = useState({})
    const [showEditOrderModal, setShowEditOrderModal] = useState(false)
    const [showEditTransportDetailsModal, setShowEditTransportDetailsModal] = useState(false)
    const [showAddReturnedItemModal, setShowAddReturnedItemModal] = useState(false)
    const [showTallyInvoiceModal, setShowTallyInvoiceModal] = useState(false)
    const [initCalled, setInitCalled] = useState(false)

    const url = useLocation();
    const navigate = useNavigate();
    const id = url.pathname.split("/")[3];

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const orderDetails = useMutation("orderDetails", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                setOrder(data.data);
                setUser(allUsersSignal.value[data?.data?.userId]);
                setDealer(data?.data?.dealer)
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");

            }
            navigate("/dashboard/orders");
        }
    })

    const getInvoice = useQuery("invoice", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2/export-invoice/${order?.id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            responseType: 'arraybuffer'
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `invoice-${order?.id}.pdf`);
                document.body.appendChild(link);
                link.click();
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }

    });
    useEffect(() => {
        orderDetails.mutate()
        setInitCalled(true)
    }, [])

    const updateOrderStageMutation = useMutation((data) => axios.put(`${DEV_SERVER}/order/v2/updateOrderStage/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data?.data
            if (data.status) {
                toast.success(data.message);
                setOrder({ ...order, ...data?.data })
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const deleteOrderMutation = useMutation((id) => axios.delete(`${DEV_SERVER}/order/v2/${id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data?.data
            if (data.status) {
                toast.success(data.message);
                navigate("/dashboard/orders");
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleOrderStageUpdate = async (stage, isCompleted) => {
        let data = {
            id: id,
            body: {
                orderStage: stage?.name,
                isCompleted: isCompleted
            }
        }

        updateOrderStageMutation.mutate(data);
    }

    const handleDeleteOrder = () => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this order?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteOrderMutation.mutate(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    const orderItemsColumns = [
        {
            name: "Product Name",
            selector: "productId",
            cell: (row) => {
                return <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                    {(order?.products[row?.productId]?.images && order?.products[row?.productId]?.images?.length > 0 && order?.products[row?.productId]?.images[0]?.url != "") && <Zoom><img src={(order?.products[row?.productId]?.images && order?.products[row?.productId]?.images?.length > 0) && order?.products[row?.productId]?.images[0]?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "40px", height: "40px", borderRadius: "10px" }} /></Zoom>}
                    <span className='d-flex flex-column my-auto'>
                        <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{order?.products[row?.productId]?.name}</Tooltip>}>
                            <span><h6>{order?.products[row?.productId]?.name}</h6></span>
                        </OverlayTrigger>
                        <p className='mb-1' style={{ color: "#8A97BC" }}>Pkg: {row?.packagingType}</p>
                        {(row?.note && row?.note !== "") && <p className='mb-0' style={{ color: "#8A97BC", fontSize: "10px" }}>Note: {row?.note}</p>}
                    </span>
                </div>
            },
            center: true,
        },
        {
            name: "Quantity",
            selector: "quantity",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.quantity}</Tooltip>}>
                    <span>{row?.quantity}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Price",
            selector: "price",
            center: true,
        },
        {
            name: "Discount (in %)",
            selector: "discount",
            center: true,
            cell: (row) => {
                return `${row?.discount || 0}%`
            }
        },
        {
            name: "Total",
            selector: "total",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{
                    `₹ ${parseFloat((row?.quantity * row?.price) - (row?.quantity * row?.price * row?.discount / 100)).toFixed(2)}`
                }</Tooltip>}>
                    <span>{`₹ ${parseFloat((row?.quantity * row?.price) - (row?.quantity * row?.price * row?.discount / 100)).toFixed(2)}`}</span>
                </OverlayTrigger>
            }
        }
    ]

    const returnedItemsColumns = [
        {
            name: "Product Name",
            selector: "productId",
            cell: (row) => {
                return <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                    <Zoom><img src={order?.products[row?.productId]?.images?.length > 0 && order?.products[row?.productId]?.images[0]?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "30px", height: "30px", borderRadius: "10px" }} /></Zoom>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{order?.products[row?.productId]?.name}</Tooltip>}>
                        <span>{order?.products[row?.productId]?.name}</span>
                    </OverlayTrigger>
                </div>
            },
            center: true,
        },
        {
            name: "Quantity",
            selector: "quantity",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.quantity}</Tooltip>}>
                    <span>{row?.quantity}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Packaging Type",
            selector: "packagingType",
            center: true,
        },
        {
            name: "Timestamp",
            selector: "createdAt",
            center: true,
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{moment(row?.createdAt).format("DD/MM/YY hh:mm")}</Tooltip>}>
                    <span>{moment(row?.createdAt).format("DD/MM/YY hh:mm")}</span>
                </OverlayTrigger>
            }
        }
    ]

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {getInvoice.isLoading && <div>
                <TopLoader backgroundColor="#eee6ff" show fixed={true} color="#0000e4" />
            </div>}
            {(orderDetails?.isLoading || orderDetails?.isFetching || !initCalled) ?
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <div className="spinner-border text-primary m-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "1.2rem" }}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <span className='d-flex flex-column'>
                                    <span className='d-flex'>
                                        <h4>Order #{order?.orderId}</h4>
                                        <Badge bg={'none'} style={{ backgroundColor: organisationSignal?.value?.orderStageColors[order?.currentOrderStage] }} className="float-left m-auto ms-2 mt-1">{order?.currentOrderStage}</Badge>
                                    </span>
                                    <p>{moment(order?.createdAt).format("DD MMM YYYY")}</p>
                                </span>

                                <span className='d-flex' style={{ columnGap: "0.5rem" }}>
                                    {(userSignal?.value?.user?.isAdmin && organisationSignal?.value?.isOrderModuleActivated && organisationSignal?.value?.isTallyIntegrationActivated) &&
                                        <Button variant='outline-primary' size='sm' onClick={() => {
                                            if (order?.isTallySynced) {
                                                confirmAlert({
                                                    title: 'Confirm to sync',
                                                    message: 'This order is already synced with Tally. Are you sure you want to sync it again?',
                                                    buttons: [
                                                        {
                                                            label: 'Yes',
                                                            onClick: () => setShowTallyInvoiceModal(true)
                                                        },
                                                        {
                                                            label: 'No',
                                                            onClick: () => { }
                                                        }
                                                    ]
                                                });
                                            } else {
                                                setShowTallyInvoiceModal(true)
                                            }
                                        }}>
                                            <i className='fa fa-sync' /> Sync
                                        </Button>
                                    }
                                    <Button variant='outline-secondary' size='sm' onClick={() => getInvoice.refetch({ cancelRefetch: true })}>
                                        <i className='fa fa-download' /> Download
                                    </Button>
                                    <Button variant='outline-dark' size='sm' onClick={() => setShowEditOrderModal(true)}>
                                        <i className="fas fa-edit"></i> Edit
                                    </Button>
                                    <Button variant='outline-danger' size='sm' onClick={handleDeleteOrder}>
                                        <i className='fa fa-trash' /> Delete
                                    </Button>
                                </span>
                            </div>
                        </Col>

                        <Col lg="12">
                            <Row className="row-cols-1">
                                <div className="d-slider1 ">
                                    <Swiper
                                        className="p-0 m-0 mb-2 list-inline "
                                        slidesPerView={5}
                                        spaceBetween={32}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            550: { slidesPerView: 2 },
                                            991: { slidesPerView: 3 },
                                            1400: { slidesPerView: 3 },
                                            1500: { slidesPerView: 4 },
                                            1920: { slidesPerView: 4 },
                                            2040: { slidesPerView: 7 },
                                            2440: { slidesPerView: 8 }
                                        }}

                                    >
                                        <SwiperSlide className="card card-slide">
                                            <div className="card-body">
                                                <div className="progress-widget">
                                                    <Circularprogressbar
                                                        stroke={variableColors.primary}
                                                        width="60px"
                                                        height="60px"
                                                        Linecap="rounded"
                                                        trailstroke="#ddd"
                                                        strokewidth="4px"
                                                        style={{ width: 60, height: 60 }}
                                                        value={90}
                                                        id="circle-progress-01"
                                                    >
                                                        {order?.totalAmount === 0 ?
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                />
                                                            </svg> :
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24px"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                />
                                                            </svg>}
                                                    </Circularprogressbar>
                                                    <div className="progress-detail">
                                                        <p className="mb-2">Total Amount</p>
                                                        <h4 className="counter">
                                                            ₹ {order?.totalAmount > 1000 ? parseFloat(order?.totalAmount / 1000).toFixed(2) + "K" : parseFloat(order?.totalAmount).toFixed(2)}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="card card-slide" >
                                            <div className="card-body">
                                                <div className="progress-widget">
                                                    <Circularprogressbar
                                                        stroke={variableColors.info}
                                                        width="60px"
                                                        height="60px"
                                                        Linecap="rounded"
                                                        trailstroke="#ddd"
                                                        strokewidth="4px"
                                                        style={{ width: 60, height: 60 }}
                                                        value={45}
                                                        id="circle-progress-01"
                                                    >
                                                        {order?.subTotal === 0 ?
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                />
                                                            </svg> :
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24px"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                />
                                                            </svg>}
                                                    </Circularprogressbar>
                                                    <div className="progress-detail">
                                                        <p className="mb-2">Sub Total</p>
                                                        <h4 className="counter">
                                                            ₹ {order?.subTotal > 1000 ? parseFloat(order?.subTotal / 1000).toFixed(2) + "K" : parseFloat(order?.subTotal).toFixed(2)}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="card card-slide" >
                                            <div className="card-body">
                                                <div className="progress-widget">
                                                    <Circularprogressbar
                                                        stroke={variableColors.primary}
                                                        width="60px"
                                                        height="60px"
                                                        Linecap="rounded"
                                                        trailstroke="#ddd"
                                                        strokewidth="4px"
                                                        style={{ width: 60, height: 60 }}
                                                        value={75}
                                                        id="circle-progress-01"
                                                    >
                                                        {parseFloat(order?.totalAmount - order?.subTotal) === 0 ?
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                />
                                                            </svg> :
                                                            <svg
                                                                className=""
                                                                width="24"
                                                                height="24px"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                />
                                                            </svg>}
                                                    </Circularprogressbar>
                                                    <div className="progress-detail">
                                                        <p className="mb-2">Taxes + Shipping</p>
                                                        <h4 className="counter">
                                                            ₹ {(order?.totalAmount - order?.subTotal) > 1000 ? parseFloat((order?.totalAmount - order?.subTotal) / 1000).toFixed(2) + "K" : parseFloat((order?.totalAmount - order?.subTotal)).toFixed(2)}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className=" card card-slide">
                                            <div className="card-body">
                                                <div className="progress-widget">
                                                    <img
                                                        style={{ width: "60px", height: "60px" }}
                                                        src={(user?.profileURL === "" || user?.profileURL === undefined) ? avatar1 : user?.profileURL}
                                                        className="rounded-circle avatar-xs"
                                                        alt="friend"
                                                    />
                                                    <div className="progress-detail">
                                                        <p className="mb-2">{user?.name || "NA"}</p>
                                                        <h6 className="counter">
                                                            {`Commission (${order?.userCommissionInPercentage}%): ₹ ${parseFloat(order?.userCommissionInAmount).toFixed(2)}`}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>

                                        <div className="swiper-button swiper-button-next"></div>
                                        <div className="swiper-button swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                            </Row>
                        </Col>

                        <Col lg="12">
                            <Row className='flex-wrap' style={{ flexShrink: 1, flexFlow: "wrap" }}>
                                <Col lg="9" className='d-flex flex-column'>
                                    <Col lg="12">
                                        <Card>
                                            <Card.Body>
                                                {<DataTable
                                                    defaultSortAsc={false}
                                                    columns={orderItemsColumns}
                                                    data={order?.orderItems}
                                                    pagination={false}
                                                    customStyles={{
                                                        headCells: {
                                                            style: {
                                                                fontSize: "1.1rem",
                                                                color: "black"
                                                            },
                                                        },
                                                    }}
                                                />}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg="12" className='d-flex justify-content-between'>
                                        <Col lg="4">
                                            <Card>
                                                <Card.Header><h4>Order Stage</h4></Card.Header>
                                                <Card.Body>
                                                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                                                        <ul className="list-inline p-0 m-0">

                                                            {order?.orderStages?.length && order?.orderStages?.map((stage, i) => {
                                                                let color = organisationSignal?.value?.orderStageColors[stage?.name] || "black";
                                                                return (
                                                                    <li style={{ fontSize: "1.2rem" }}>
                                                                        <div className="timeline-dots1">
                                                                            <Form.Group color='success'>
                                                                                <Form.Check disabled={updateOrderStageMutation?.isLoading} style={{ width: "40px", height: "40px" }} checked={stage?.isCompleted} onChange={(e) => handleOrderStageUpdate(stage, e.target.checked)} />
                                                                            </Form.Group>
                                                                        </div>
                                                                        {/* <h6 className="mb-1" style={{backgroundColor: color, color: 'white'}}>{stage?.name}</h6> */}
                                                                        <Badge bg={'none'} style={{ backgroundColor: color }} className="float-left mb-1">{stage?.name}</Badge><br />
                                                                        {stage?.createdAt ? <small className="float-right mt-1">{moment(stage?.createdAt).format("DD/MM/YY hh:mm A")}</small> : <></>}
                                                                        <div className="d-inline-block w-100 mt-2">
                                                                            {stage?.updatedBy !== "000000000000000000000000" && <p className='d-flex'>
                                                                                <img
                                                                                    style={{ width: "30px", height: "30px" }}
                                                                                    src={(allUsersSignal?.value[stage?.updatedBy]?.profileURL === "" || allUsersSignal?.value[stage?.updatedBy]?.profileURL === undefined) ? avatar1 : allUsersSignal?.value[stage?.updatedBy]?.profileURL}
                                                                                    className="rounded-circle avatar-xs"
                                                                                    alt="friend"
                                                                                />
                                                                                <p className='ms-2'>{allUsersSignal?.value[stage?.updatedBy]?.name}</p>
                                                                            </p>}
                                                                        </div>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg="7">
                                            <Card>
                                                <Card.Header><h4>Order Summary</h4></Card.Header>
                                                <Card.Body>
                                                    <div className="d-flex flex-column mt-2" style={{ rowGap: "1rem" }}>
                                                        <div className='px-2 d-flex justify-content-between align-items-center'>
                                                            <p className='mb-0' style={{ fontSize: "1.2rem" }}>Sub Total</p>
                                                            <p className='mb-0' style={{ fontSize: "1rem" }}>₹ {parseFloat(order?.subTotal).toFixed(2)}</p>
                                                        </div>

                                                        {order?.taxes?.length > 0 ? order?.taxes?.map((tax) => {
                                                            return (

                                                                <div className='px-2 d-flex justify-content-between align-items-center'>
                                                                    <p className='mb-0' style={{ fontSize: "1.2rem" }}>{`${tax?.name} ${tax?.taxInPercentage ? "(" + tax?.taxInPercentage + "%)" : ''}`}</p>
                                                                    <p className='mb-0' style={{ fontSize: "1rem" }}>₹ {parseFloat(tax?.taxInAmount).toFixed(2)}</p>
                                                                </div>
                                                            )
                                                        })
                                                            : <></>
                                                        }

                                                        <div className='px-2 d-flex justify-content-between align-items-center'>
                                                            <p className='mb-0' style={{ fontSize: "1.2rem" }}>Shipping Charges</p>
                                                            <p className='mb-0' style={{ fontSize: "1rem" }}>₹ {parseFloat(order?.shippingCharges).toFixed(2)}</p>
                                                        </div>
                                                        <div className='px-2 d-flex justify-content-between align-items-center pt-2' style={{ borderTop: "1px solid grey" }}>
                                                            <p className='mb-0' style={{ fontSize: "1.4rem" }}><b>Total Amount</b></p>
                                                            <p className='mb-0' style={{ fontSize: "1.2rem" }}>₹ {parseFloat(order?.totalAmount).toFixed(2)}</p>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Col>
                                </Col>
                                <Col lg="3">
                                    <Card>
                                        <Card.Body>
                                            <div className='d-flex flex-column pb-2' style={{ borderBottom: "1px solid rgba(145 158 171 / 0.2)" }}>
                                                <h5>Note</h5>
                                                <p className='mb-0 ms-2 mt-2'>{order?.note !== "" ? order?.note : "NA"}</p>
                                            </div>
                                            <div className='d-flex flex-column pb-2 mt-3' style={{ borderBottom: "1px solid rgba(145 158 171 / 0.2)" }}>
                                                <h5>Customer</h5>
                                                <div className="d-flex flex-column mt-2">
                                                    <div className='px-2 d-flex justify-content-between align-items-start'>
                                                        <p className='mb-0 me-2'><b>Name</b></p>
                                                        <p className='mb-0'>{dealer?.name}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start'>
                                                        <p className='mb-0 me-2'><b>Phone</b></p>
                                                        <p className='mb-0'>{dealer?.phoneNumber}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start'>
                                                        <p className='mb-0 me-2'><b>GST No.</b></p>
                                                        <p className='mb-0'>{dealer?.gstin}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column pb-2 mt-3' style={{ borderBottom: "1px solid rgba(145 158 171 / 0.2)" }}>
                                                <h5>Shipping Address</h5>
                                                <p className='mb-0 ms-2 mt-2'>{order?.shippingAddress?.addressL1 + " " + order?.shippingAddress?.landmark}, {order?.shippingAddress?.city} - {order?.shippingAddress?.pincode}, {order?.shippingAddress?.state}</p>
                                            </div>
                                            <div className='d-flex flex-column pb-2 mt-3' style={{ borderBottom: "1px solid rgba(145 158 171 / 0.2)" }}>
                                                <h5>Billing Address</h5>
                                                <p className='mb-0 ms-2 mt-2'>{order?.billingAddress?.addressL1 + " " + order?.billingAddress?.landmark}, {order?.billingAddress?.city} - {order?.billingAddress?.pincode}, {order?.billingAddress?.state}</p>
                                            </div>
                                            <div className='d-flex flex-column pb-2 mt-3' style={{ position: "relative", borderBottom: "1px solid rgba(145 158 171 / 0.2)" }}>
                                                <h5>Transport Details</h5>
                                                <i className='fa fa-edit position-absolute' style={{ cursor: "pointer", right: "5%", top: "5%" }} onClick={() => setShowEditTransportDetailsModal(true)}></i>
                                                <div className="d-flex flex-column mt-2">
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Eway Bill No.</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}>{order?.transportDetails?.ewayBillNumber}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Doc No.</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}>{order?.transportDetails?.docNumber}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Vehicle No.</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}>{order?.transportDetails?.vehicleNumber}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Courier Name</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}>{order?.transportDetails?.courierName}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Contact Person</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}>{order?.transportDetails?.contactPersonName ? <span>{`${order?.transportDetails?.contactPersonName} ${order?.transportDetails?.contactPersonNumber ? "(" + order?.transportDetails?.contactPersonNumber + ")" : ""}`}</span> : <span></span>}</p>
                                                    </div>
                                                    <div className='px-2 d-flex justify-content-between align-items-start' style={{ columnGap: "1rem" }}>
                                                        <p className='mb-0' style={{ fontSize: "15px", whiteSpace: "nowrap" }}><b>Tracking Link</b></p>
                                                        <p className='mb-0' style={{ fontSize: "14px" }}><a href={order?.transportDetails?.trackingLink}>{order?.transportDetails?.trackingLink}</a></p>
                                                    </div>
                                                </div>
                                                {/* Add this block below Transport Details */}
                                                {order?.media && order.media.length > 0 && (
                                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                                        {order.media.map((item, idx) => (
                                                            <Zoom key={item._id || idx}>
                                                                <img
                                                                    src={item.url}
                                                                    alt={`Order Media ${idx + 1}`}
                                                                    style={{
                                                                        width: "70px",
                                                                        height: "70px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                        border: "1px solid #eee",
                                                                        background: "#fafafa"
                                                                    }}
                                                                    onError={e => { e.target.style.display = "none"; }}
                                                                />
                                                            </Zoom>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Tab.Container>
            }


            {showEditOrderModal && <AddEditOrder show={showEditOrderModal} order={order} close={() => setShowEditOrderModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showEditTransportDetailsModal && <EditTransportDetails show={showEditTransportDetailsModal} order={order} close={() => setShowEditTransportDetailsModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showTallyInvoiceModal && <TallyInvoiceModal show={showTallyInvoiceModal} order={order} close={() => setShowTallyInvoiceModal(false)} refetchOrder={() => orderDetails.mutate()} />}

            {showAddReturnedItemModal && <AddReturnedItemModal show={showAddReturnedItemModal} order={order} close={() => setShowAddReturnedItemModal(false)} refetchOrder={() => orderDetails.mutate()} />}
        </Fragment>
    )
}